export default __webpack_public_path__ + "static/media/squirtle.69f1f33c.jpg";